import type { ComponentProps, CSSProperties } from "react"
import cn from "@/v2-ui/utils/utils.cn"

export type IconCustomNewFolderProps = ComponentProps<"svg">

function IconCustomNewFolder(props: IconCustomNewFolderProps) {
  const {
    className,
    style,
    stroke = "currentColor",
    strokeWidth = 2,
    strokeLinecap = "round",
    strokeLinejoin = "round",
    fill: _ignoredFill,
    width: _ignoredWidth,
    height: _ignoredHeight,
    ...svgProps
  } = props

  const sizeStyle: CSSProperties = {
    width: style?.width ?? 14,
    height: style?.height ?? 14,
    flexShrink: 0,
    ...style,
  }

  return (
    <svg
      className={cn("block", className)}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={sizeStyle}
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap={strokeLinecap}
      strokeLinejoin={strokeLinejoin}
      aria-hidden
      {...svgProps}
    >
      <path d="M12 10v6" fill="none" />
      <path d="M9 13h6" fill="none" />
      <path
        d="M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z"
        fill="none"
      />
    </svg>
  )
}

export default IconCustomNewFolder
